module.exports = __webpack_public_path__ + "static/media/change.e2840be4.svg";